import { OrderManagementInterface } from "@/interface/order.inteface";
import { OrderManagementType } from "@/types/orders";
import { PriceType } from "@/types/business/item.type";
import { OrderNotes, PriceMoney } from "@/modules/location";
import { OrderNotesInterface } from "@/interface/business/item.interface";

export default class OrderManagement implements OrderManagementInterface {
  id: string = "";
  serial_number: string = "";
  name: string = "";
  creation_time: string = "";
  end_time: string = "";
  location_id: string = "";
  status: string = "";
  sale_option: string = "";
  payment_methods: string = "";
  payment_status: string = "";
  customer_name: string = "";
  source: string = "";
  total?: PriceType;
  sale_id: string = "";
  transaction_id: string = "";
  notes: OrderNotesInterface;

  constructor(data: OrderManagementType) {
    this.id = data.id;
    this.serial_number = data.serial_number;
    this.creation_time = data.creation_time;
    this.end_time = data.end_time;
    this.location_id = data.location_id;
    this.name = data.name;
    this.source = data.source;
    this.status = data.status;
    this.payment_status = "";
    this.total = new PriceMoney({ amount: data.total_amount || 0 });
    this.sale_id = data?.sale?.id || "";
    this.transaction_id = data?.transaction_id || "";
    this.notes = new OrderNotes(data?.notes);
    this.setOrderOption(data);
    this.setPaymentMethods(data);
  }

  /**
   * Set Sale Option
   * @return {void}
   */
  public setOrderOption(data) {
    const order_option = data?.sale?.order_option;
    this.sale_option = order_option?.name || "";
  }

  /**
   * Set Payment Methods
   * @return {void}
   */
  public setPaymentMethods(data) {
    this.payment_methods = data.payment_methods.flatMap((item) => item.name).join(", ");
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public createdAt(): string {
    return window.moment.utc(this.creation_time).local().fromNow();
  }

  /**
   * End At Formatter
   * @return {string}
   */
  public endAt(): string {
    const end_time = window.moment.utc(this.end_time).local();
    return end_time.isValid() ? end_time.fromNow() : "-";
  }

  /**
   * End At Formatter
   * @return {string}
   */
  public paymentStatus(): string {
    return this.notes?.payment_status ? this.notes?.payment_status : "";
  }
}
